module.exports = ".item-input {\r\n    padding: 5px 0;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/setting/document/document.component.css
// module id = ./src/app/app_manager/app_element/setting/document/document.component.css
// module chunks = main